define('viewmodels/Reporting/SummaryReport',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger'], function (ko, router, app, appsecurity, navigation, system, logger) {
    var SRViewModel ={
        loadFindingReport: loadFindingReport,
        attached: attached,
        UserID: ko.observable()
    }
    return SRViewModel;

    function attached() {
        GetUser();
        }
    
    function GetUser() {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Reporting/GetUser",
                type: "GET",
                headers: headers,

            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetUser() method in Reports.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {

                SRViewModel.UserID(jsonResult);
                loadFindingReport();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetUser() method in Reports.js';
                logger.logMessage(msg);
            }
        }

    }
    function loadFindingReport() {
        
        $('#divFindingsReport').html('');
        var homeurl = homeUrlLocation;
        var url = window.location.hash;
        $('<iframe>', {
            src: homeurl + 'SSRSReportViewer.aspx?UserID=' + SRViewModel.UserID(),
            id: 'iframe_FINDINGS',
            frameborder: 0,
            style: 'display: block; width: 100%; height: 1500px; margin-left: 0px;',
        }).appendTo('#divFindingsReport');
    }
});
